/**
 * Automatic SCSS Import System
 * This file uses Vite's glob import to automatically import all SCSS files
 * 
 * NOTE: Mixins and variables are automatically available in all SCSS files
 * via vite.config.js preprocessorOptions. No need to import them manually!
 */

// Import core base styles (non-mixin files that generate actual CSS)
// ORDER MATTERS: Variables → Reset/Base → Utilities → Layout → Components

// 1. CSS Custom Properties FIRST (needed by everything else)
import './core/01_variables.scss';

// 2. Base/Reset styles (removes default browser styles, uses variables)
import './core/base.scss';

// 3. Utilities and helpers
import './core/05_utilities.scss';
import './core/06_grid.scss';
import './core/helpers.scss';
import './core/layout.scss';
import './core/spacing.scss';
import './core/content-spacing.scss'; // Smart spacing for mixed content
import './core/colors.scss';
import './core/display.scss';
import './core/animations.scss';

// 3. Specific page/feature styles
import './core/events-cal.scss';
import './core/profile.scss';
import './core/cart.scss';
import './core/courses.scss';


// Component styles - import in hierarchical order

const atomStyles = import.meta.glob([
  '../../views/components/atoms/**/*.scss',
], { eager: true });

const moleculeStyles = import.meta.glob([
  '../../views/components/molecules/**/*.scss',
], { eager: true });

const organismStyles = import.meta.glob([
  '../../views/components/organisms/**/*.scss',
], { eager: true });

const contentStyles = import.meta.glob([
  '../../views/components/content/**/*.scss',
], { eager: true });

const pageStyles = import.meta.glob([
  '../../views/pages/**/*.scss',
], { eager: true });

// Global styles
const globalStyles = import.meta.glob([
  '../../views/global/**/*.scss',
], { eager: true });

// Dev tools
const devToolStyles = import.meta.glob([
  '../../views/dev-tools/**/*.scss',
], { eager: true });

// Log imported files for debugging (always show during build)
console.log('🎨 SCSS Files Loaded:');
console.log('Global:', Object.keys(globalStyles));
console.log('Atoms:', Object.keys(atomStyles));
console.log('Molecules:', Object.keys(moleculeStyles));
console.log('Organisms:', Object.keys(organismStyles));
console.log('Pages:', Object.keys(pageStyles));
console.log('Dev Tools:', Object.keys(devToolStyles));

// Export for potential use in other files
export {
  globalStyles,
  atomStyles,
  moleculeStyles,
  organismStyles,
  contentStyles,
  pageStyles,
  devToolStyles
};
